import { Coffee, BellRing, BedDouble, MapPin } from "lucide-react";
import { FadeUp } from "./Reveal";
import { useLang } from "../i18n/LanguageContext";

const ICONS = [Coffee, BellRing, BedDouble, MapPin];

export default function FeaturedServices() {
  const { T } = useLang();
  return (
    <section className="relative py-14 md:py-24" data-testid="featured-services-section">
      <div className="container-x">
        <div className="mt-12 grid grid-cols-2 gap-3 sm:gap-5 lg:grid-cols-4">
          {T.featured.map((s, i) => {
            const Icon = ICONS[i];
            return (
              <FadeUp key={s.t} delay={i * 0.09}>
                <div
                  data-testid={`service-card-${i}`}
                  className="group h-full rounded-2xl border border-federasol-terra/10 bg-white/80 p-4 shadow-[0_10px_30px_-5px_rgba(64,49,47,0.06)] transition-all duration-500 ease-soft hover:-translate-y-1.5 hover:shadow-[0_24px_50px_-20px_rgba(166,93,71,0.25)] sm:rounded-3xl sm:p-7"
                >
                  <div className="flex h-10 w-10 items-center justify-center rounded-full bg-federasol-blush text-federasol-terra transition-colors duration-500 group-hover:bg-federasol-rose group-hover:text-white sm:h-12 sm:w-12">
                    <Icon className="h-4 w-4 sm:h-6 sm:w-6" strokeWidth={1.6} />
                  </div>
                  <h3 className="mt-3 font-serif text-base font-semibold text-federasol-cocoa sm:mt-6 sm:text-xl">
                    {s.t}
                  </h3>
                  <p className="mt-1.5 text-xs leading-relaxed text-federasol-muted sm:mt-2.5 sm:text-sm">{s.d}</p>
                </div>
              </FadeUp>
            );
          })}
        </div>
      </div>
    </section>
  );
}
